/** @jsxImportSource @emotion/react */
import StubImage from 'modules/ud-ui/components/images/stub-image.png';
import React from 'react';
import type { DivProps } from 'typings';
import * as S from './styles';

interface IStubPictureProps extends DivProps {}

function StubPicture(props: IStubPictureProps) {
  const { ...rest } = props;

  return (
    <S.MainBlock {...rest}>
      <img src={StubImage} alt="stub-phone-tablet" />
    </S.MainBlock>
  );
}

export default StubPicture;
